import dayjs from 'dayjs';
import { COLORS } from '../constants/colors';

export const getReservationStatus = (reservation) => {
  const now = dayjs();
  const checkIn = dayjs(reservation.checkInDate || reservation.checkinDate);
  const checkOut = dayjs(reservation.checkOutDate || reservation.checkoutDate);
  const status = reservation.status?.toLowerCase() || 'confirmed';

  const isHourlyReservation = reservation.isHourly || (checkOut.diff(checkIn, 'hour') < 24 && checkOut.diff(checkIn, 'hour') > 0);

  if (isHourlyReservation) {
    if (status === 'cancelled') return { color: COLORS.reservation.cancelled, label: 'Cancelada' };
    if (now.isBetween(checkIn, checkOut)) return { color: COLORS.reservation.inHouse, label: 'En Uso' };
    if (checkIn.isSame(now, 'day') && checkIn.isAfter(now)) {
      return { color: COLORS.reservation.arriving, label: `Llega ${checkIn.format('HH:mm')}` };
    }
    return { color: COLORS.reservation.confirmed, label: `${checkIn.format('HH:mm')}-${checkOut.format('HH:mm')}` };
  }

  if (status === 'cancelled') return { color: COLORS.reservation.cancelled, label: 'Cancelada' };
  if (status === 'no-show') return { color: COLORS.reservation.noShow, label: 'No Show' };

  if (reservation.checkedIn) {
    if (reservation.checkedOut) return { color: COLORS.reservation.checkedOut, label: 'Check-out' };
    return { color: COLORS.reservation.inHouse, label: 'En Casa' };
  }

  if (checkIn.isSame(now, 'day')) return { color: COLORS.reservation.arriving, label: 'Llegando' };
  if (checkOut.isSame(now, 'day')) return { color: COLORS.reservation.departing, label: 'Saliendo' };
  if (now.isBetween(checkIn, checkOut, 'day', '()')) return { color: COLORS.reservation.inHouse, label: 'En Casa' };

  if (status === 'pending') return { color: COLORS.reservation.pending, label: 'Pendiente' };
  if (status === 'waitlist') return { color: COLORS.reservation.waitlist, label: 'Lista Espera' };

  return { color: COLORS.reservation.confirmed, label: 'Confirmada' };
};
